import { createFileRoute } from "@tanstack/react-router"
import { ActivityDto } from "../../../../@client/Theasoft_ApiServer_Activities"
import { DateOnly } from "../../../../@client/System"
import { getFormattedDate } from "../../../../utils/get-formatted-date"
import { getFormattedTimePeriod } from "../../../../utils/get-formatted-time"
import { ActivityTabs } from "./-components/ActivityTabs"

type Tab = "start" | "casts"

export const Route = createFileRoute("/app/art/activities/$id")({
  component: ActivityTabs,
  beforeLoad(context) {
    const activity = context.context.queryClient?.getQueryData<ActivityDto>([
      "/api/Activity/GetActivity",
      { activityId: parseInt(context.params.id) },
    ])
    return {
      getTitle: () =>
        activity
          ? `${getFormattedDate(activity?.date as DateOnly)} ${
              activity?.timePeriod &&
              getFormattedTimePeriod(activity?.timePeriod)
            } ${activity?.activityType.shortName} ${
              activity?.title.text
            } ${activity?.locationShort}`
          : "",
    }
  },
  validateSearch: (search: { tab: Tab }) => ({
    tab: search.tab || "start",
  }),
})
